let initialized = false;

export function initInlineLists() {
    if (initialized) return;
    initialized = true;

    const observed = new Set();
    let frame;
    const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
    };
    const resizeObserver = new ResizeObserver(schedule);

    function update() {
        frame = null;
        const lists = [...document.querySelectorAll('ul.inline-list')];
        const elements = new Set(lists.flatMap(list => [list, ...list.children]));
        observed.forEach(element => {
            if (!elements.has(element)) {
                resizeObserver.unobserve(element);
                observed.delete(element);
            }
        });
        elements.forEach(element => {
            if (!observed.has(element)) {
                observed.add(element);
                resizeObserver.observe(element);
            }
        });

        // Reset before measuring so previous offsets never accumulate.
        const separators = lists.flatMap(list => [...list.querySelectorAll('.inline-list__separator')]);
        separators.forEach(separator => separator.style.removeProperty('--inline-list-separator-offset'));
        const offsets = [];
        lists.forEach(list => {
            const items = [...list.children];
            const rtl = getComputedStyle(list).direction === 'rtl';
            items.slice(0, -1).forEach((item, index) => {
                const separator = item.querySelector('.inline-list__separator');
                const text = item.querySelector('.inline-list__text');
                const next = items[index + 1];
                if (!separator || !text) return;

                // Wrapped rows retain their attached separators without shifting into empty space.
                if (Math.abs(item.getBoundingClientRect().top - next.getBoundingClientRect().top) > 1) return;
                const textBounds = text.getBoundingClientRect();
                const nextBounds = next.getBoundingClientRect();
                const separatorBounds = separator.getBoundingClientRect();
                const midpoint = rtl
                    ? (textBounds.left + nextBounds.right) / 2
                    : (textBounds.right + nextBounds.left) / 2;
                offsets.push([separator, midpoint - (separatorBounds.left + separatorBounds.right) / 2]);
            });
        });
        offsets.forEach(([separator, offset]) => {
            separator.style.setProperty('--inline-list-separator-offset', `${offset}px`);
        });
    }

    // Page Builder can insert or replace widgets after the initial page load.
    new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
    });
    document.fonts.ready.then(schedule);
    schedule();
}
